import { all, call, fork, getContext, put, takeEvery } from 'redux-saga/effects';
import { OfferActionTypes } from './types';
import * as actions from './actions';
import * as DataActions from '../data/actions';
import * as api from '../../api/api';
import { retryAPICallChannel } from '..';
import { logout } from '../auth/actions';
import { API_CALLS } from '../../utilities/constants';
import isTesting from '../../utilities/isTesting';
import * as StudentActions from '../student/actions';
import { IOffer } from 'types';

function* handleGetActiveOffers() {
  try {
    const context = yield getContext('sagaContext');
    const idToken: any = yield call(context.getIdToken);
    if (!idToken) {
      yield put(logout());
      yield call(context.onLogout);
      console.log('Refresh Token has Expired');
      return;
    }
    let studentNo: string;
    let university: string;
    if (!isTesting) {
      studentNo = context.studentNo;
      university = context.uni;
    } else {
      studentNo = '0000003';
      university = 'TST';
    }
    const resp: IOffer[] = yield call(
      api.getActiveOffers,
      idToken,
      university,
      studentNo,
      (retryNumber: number, time: number) => {
        retryAPICallChannel.put(DataActions.retryAPICall(API_CALLS.GET_ACTIVE_OFFERS, retryNumber, time));
      },
      () => {
        retryAPICallChannel.put(DataActions.retryAPICallSuccess(API_CALLS.GET_ACTIVE_OFFERS));
      },
      (e: Error) => {
        retryAPICallChannel.put(DataActions.retryAPICallFailure(API_CALLS.GET_ACTIVE_OFFERS, e.message));
      }
    );

    const [, maybeIntakeId, maybeOfferId] = window.location.pathname.split('/');
    const hasOnlyOneOffer = resp.length === 1;
    const activeOffer = resp.find((offer: IOffer) => offer.isActive) || (hasOnlyOneOffer ? resp[0] : null);
    const shouldSetActiveOffer = maybeIntakeId === activeOffer?.intakeId && maybeOfferId === activeOffer?.offerId;
    if (activeOffer && (shouldSetActiveOffer || hasOnlyOneOffer)) {
      yield put(actions.setActiveOffer(activeOffer));
    }

    yield put(actions.getActiveOffersSuccess(resp));
  } catch (err) {
    if (err instanceof Error) {
      yield put(actions.getActiveOffersFailure(err.message));
    } else {
      yield put(actions.getActiveOffersFailure('An unknown error occured.'));
    }
  }
}

function* handleSetActiveOffer(action: ReturnType<typeof actions.setActiveOffer>) {
  try {
    const context = yield getContext('sagaContext');
    const idToken: any = yield call(context.getIdToken);
    if (!idToken) {
      yield put(logout());
      yield call(context.onLogout);
      console.log('Refresh Token has Expired');
      return;
    }
    let studentNo: string;
    let university: string;
    if (!isTesting) {
      studentNo = context.studentNo;
      university = context.uni;
    } else {
      studentNo = '0000003';
      university = 'TST';
    }

    const { intakeId, offerId, isActive } = action.payload;

    if (!isActive) {
      yield call(api.setActiveOffer, idToken, university, studentNo, intakeId, offerId);
    }

    yield put(actions.setActiveOfferSuccess());
    yield put(StudentActions.getStudentRecord(intakeId, offerId));
  } catch (err) {
    if (err instanceof Error) {
      yield put(actions.setActiveOfferFailure(err.message));
    } else {
      yield put(actions.setActiveOfferFailure('An unknown error occured.'));
    }
  }
}

function* watchGetActiveOffers() {
  yield takeEvery(OfferActionTypes.GET_ACTIVE_OFFERS, handleGetActiveOffers);
}

function* OffersSaga() {
  yield all([fork(watchGetActiveOffers)]);
  yield all([takeEvery(OfferActionTypes.SET_ACTIVE_OFFER, handleSetActiveOffer)]);
}

export default OffersSaga;
